// MODEL DEV
import { bbAxios } from '@bb/session-manager';

import { MODELS_ENDPOINT } from '../../endpoints.config';
import { SET_CURRENT_MODEL, SET_CURRENT_MODEL_DATA } from '../action-types/modelTypes';

export const SetCurrentModel = (modelId) => ({
  type: SET_CURRENT_MODEL,
  payload: modelId,
});
export const CreateModelFromInputs = (data) =>
  async function (dispatch) {
    let {
      name,
      isDeleteProtected,
      stage,
      contractType,
      templateTypes,
      defaultQuestionnaire,
      groups,
      enableBullseyeByEmail,
      generateAddendum,
      addendumTemplate,
      emailOnUpload = false,
      convertPdfToDocx = false,
      onboarding = false,
      bullseyeTrainingModels = [],
      nano_slot_model = {},
      enableRiskRouting = false,
      enableNewFsdMethod = false,
      similarityModel = '',
    } = data;

    const response = await bbAxios.post(MODELS_ENDPOINT, {
      name,
      isDeleteProtected,
      stage,
      contractType,
      templateTypes,
      defaultQuestionnaire,
      groups,
      enableBullseyeByEmail,
      generateAddendum,
      addendumTemplate,
      onboarding,
      bullseyeTrainingModels,
      emailOnUpload,
      convertPdfToDocx,
      nano_slot_model,
      enableRiskRouting,
      enableNewFsdMethod,
      similarityModel,
    });

    if (!onboarding) {
      dispatch(SetCurrentModel(response.data.modelId));
      return response.data.modelId;
    }
    return response.data;
  };

export const SetCurrentModelData = (data) => ({
  type: SET_CURRENT_MODEL_DATA,
  payload: data,
});
